import * as React from 'react'

import asyncAction from 'modules/core/lib/asyncAction'

import { useQuestionCategory } from 'modules/reviews/hooks/useQuestionCategory'
import { useReviewShowContext } from 'modules/reviews/pages/performance/Show/hooks'
import questionConfigs from 'modules/reviews/store/collections/questionConfigs'

import RemoveCategoryModal from './RemoveCategoryModal'

interface Props {
  formId: number
  onClose: () => void
  questionCategoryId: number
}

// TODO: review this interface used in `deleteQuestionCategory`
// interface DataObject {
//   id: number;
// }
export default function RemoveCategoryModalContainer({
  formId,
  questionCategoryId,
  onClose,
}: Props) {
  const { questionCategory } = useQuestionCategory(questionCategoryId, formId)
  const { updateCanBeStarted } = useReviewShowContext()

  const refetchQuestionConfigs = () =>
    questionConfigs.fetch({
      remove: false,
      data: {
        surveys_question_group_config_id:
          questionCategory?.attributes.surveys_question_group_config_id,
        surveys_form_id: formId,
      },
    })

  const deleteQuestionCategory = async () => {
    if (!questionCategory) return

    const { success, value } = await asyncAction(() =>
      questionCategory.destroy({ data: { surveys_form_id: formId } })
    )

    // We reorder all question configs in backend
    if (success) {
      await refetchQuestionConfigs()
      await updateCanBeStarted()
    }

    return value
  }

  if (!questionCategory) return null

  return (
    <RemoveCategoryModal
      category={questionCategory}
      questionsCount={questionCategory.questionConfigs.length}
      onClose={onClose}
      onSubmit={deleteQuestionCategory}
    />
  )
}
